/*
 * @Author: whj
 * @Date: 2021-11-09 10:00:34
 * @Last Modified by: whj
 * @Last Modified time: 2025-09-18 13:34:25
 */

// 静态资源地址
export const resourcePath: string =
  "https://web-resource.17m3.com/m3guo/202408/cdk-ueqk/";

export const phoneMax: Number = 750;

// 图片预加载
// export const preloadData = {};

// 大区
export const areaData = {
  "110": "测试二区",
  "100": "测试一区",
  "1": "火烧赤壁",
  "2": "草船借箭",
  "6": "荆州之战",
  "7": "青梅煮酒",
  "8": "官渡之战",
  "9": "桃园结义",
  "11": "九伐中原",
  "16": "怀旧服",
  "17": "铜雀台(WeGame1)",
  "18": "凤仪亭(WeGame2)",
  "19": "火凤燎原",
  "20": "卧龙出渊",
  "21": "长生殿(steam)",
  "22": "逍遥津(WeGame3)",
  "23": "单刀赴会",
  "24": "再借东风",
};
